import { Stack } from '@mui/material';
import type { GetContractsResponse } from '@weft/api-definition';
import dayjs from 'dayjs';
import React from 'react';
import { PlansSumCard } from './PlansSumCard';

export type PlansHeaderSummarizeProps = {
  data: Omit<GetContractsResponse, 'contracts'>;
};

type SummaryDataType = {
  title: string;
  value: number | undefined;
}[];

export const PlansHeaderSummarize: React.FC<PlansHeaderSummarizeProps> = ({
  data,
}) => {
  const summaryData = getSummaryData(data);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ marginBottom: '24px' }}
    >
      {summaryData.map((item, index) => (
        <PlansSumCard
          key={index}
          title={item.title}
          value={item.value}
        />
      ))}
    </Stack>
  );
};

export function getSummaryData(data: PlansHeaderSummarizeProps['data']): SummaryDataType {
  const currentMonth = dayjs().format('MMMM');

  return [
    {
      title: `${currentMonth} Renewals`,
      value: data?.countedUpcomingRenewalContracts,
    },
    { title: 'Active Contracts', value: data?.countedActiveContracts },
    { title: 'Inactive Contracts', value: data?.countedInactiveContracts },
    { title: 'Terminated Contracts', value: data?.countedTerminatedContracts },
  ];
}
